import React from 'react';
import PropTypes from 'prop-types';
import MuiCircularProgress from '@mui/material/CircularProgress';

const SIZE_MAP = {
    mini: 16,
    tiny: 24,
    small: 32,
    large: 64,
};

const DEFAULT_SIZE = 32;

const CircularProgress = ({
    className,
    size,
}) => {
    const progressSize = SIZE_MAP[size] || DEFAULT_SIZE;

    return (
        <MuiCircularProgress
            className={className}
            size={progressSize}
            enableTrackSlot
        />
    );
};

CircularProgress.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf([
        'mini',
        'tiny',
        'small',
        'large',
    ]),
};

export default CircularProgress;
